import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "../../styles/AdsStyle.css"; // Create this CSS file
import axios from "../../axiosinstens";
import { environment } from "../../environment";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SectionAds = () => {
  const [ads, setAds] = useState([]);

  const getAds = async () => {
    try {
      const response = await axios.get("getSeminar");
      const eventsData = response.data.seminar;
      const today = new Date();
      const pastEventsWithAds = eventsData.filter((event) => {
        const eventDate = new Date(event.start_date);
        return (
          eventDate > today && event.adsimage && event.adsimage.trim() !== ""
        );
      });
      setAds(pastEventsWithAds);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getAds();
  }, []);

  const settings = {
    dots: false,
    infinite: ads.length > 1, // Infinite scroll only when >1 ad
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: Math.min(ads.length, 3),
    slidesToScroll: Math.min(ads.length, 2),
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(ads.length, 2),
          slidesToScroll: 1,
        },
      },
    ],
  };

  return ads.length > 0 ? (
    <div className="ads-section">
      <Slider {...settings}>
        {ads.map((ad) => (
          <div key={ad._id} className="ad-slide">
            <a href={ad.booking_url || "#"} target="_blank" rel="noopener noreferrer">
              <img
                src={`${environment.imageBaseURL}seminar/${ad.adsimage}`}
                alt={ad.name}
                className={ads.length >= 3 ? "ad-image" : "ads-image"}
              />
            </a>
          </div>
        ))}
      </Slider>
    </div>
  ) : (
    <p> &nbsp; </p>
  );
};

export default SectionAds;
